module.exports = __webpack_public_path__ + "static/img/title.c01c703a.png";